import {
  anexosComObito,
  commonsDocs,
  molestiaGraveDocs,
  commonDocsBeneficiario,
} from './general';
import docs from './specific';

export default {
  anexosComObito: anexosComObito(),
  molestiaGraveDocs,
  commonsDocs,
  commonDocsBeneficiario,
  ...docs,
};
